export const PIXELS_POINTS_UNIT_CONVERSION = 0.75
export const FIRST_PAGE = 1
export const LAST_PAGE = -1
export const A4_HEIGHT = 1119.7137
export const A4_WIDTH = 791.7224
export const SQUARE_SIGNATURE_HEIGHT = 79.8
export const SQUARE_SIGNATURE_WIDTH = 159.6
export const ZOOM_STEP = 0.25
export const PERCENT_PADDING = 20